/* Cuenta atrás de envío (ficha, carrito y cajón). Un solo temporizador para
   todas las instancias: se registran las que hay, se recogen las que el carrito
   reinserta por AJAX (innerHTML no ejecuta <script>, por eso vive aquí y no en
   el snippet), se descartan las desconectadas y se para en pestaña oculta.
   Sólo texto: el mensaje cambia una vez por minuto. */
(function () {
  if (window.gfDispatch) return;
  var items = [];
  var timer = null;

  function madridNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' })); }
  function ymd(x) { return x.getFullYear() + '-' + ('0' + (x.getMonth() + 1)).slice(-2) + '-' + ('0' + x.getDate()).slice(-2); }

  function make(el) {
    var cutoff = el.getAttribute('data-dispatch-cutoff') || '12:30';
    var ch = parseInt(cutoff.split(':')[0], 10), cm = parseInt(cutoff.split(':')[1], 10);
    // Festivos YYYY-MM-DD: cuentan como no laborable, el corte salta al siguiente día hábil.
    var holidays = (el.getAttribute('data-dispatch-holidays') || '').split(/[\s,;]+/).filter(Boolean);
    var it = { el: el, msg: el.querySelector('[data-dispatch-msg]'), lastMin: -1 };
    function isBiz(x) { var g = x.getDay(); if (g < 1 || g > 5) return false; return holidays.indexOf(ymd(x)) === -1; }
    function nextCutoff(now) {
      var d = new Date(now); d.setHours(ch, cm, 0, 0);
      if (now < d && isBiz(d)) return d;
      do { d.setDate(d.getDate() + 1); d.setHours(ch, cm, 0, 0); } while (!isBiz(d));
      return d;
    }
    it.tick = function (n) {
      if (n.getMinutes() === it.lastMin) return;
      it.lastMin = n.getMinutes();
      var t = nextCutoff(n), diff = t - n;
      var hh = Math.floor(diff / 3600000), mm = Math.floor((diff % 3600000) / 60000);
      // Tras el corte de un viernes quedan >24h: en días se lee mejor.
      var left = hh >= 24 ? (Math.floor(hh / 24) + 'd ' + (hh % 24) + 'h') : (hh + 'h ' + mm + 'm');
      var nd = new Date(n); nd.setHours(0, 0, 0, 0); var td = new Date(t); td.setHours(0, 0, 0, 0);
      var days = Math.round((td - nd) / 86400000);
      var label = days === 0 ? 'today' : t.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
      if (it.msg) it.msg.innerHTML = 'Ships <strong>' + label + '</strong> · order within <b>' + left + '</b>';
    };
    return it;
  }

  function tickAll() {
    var n = madridNow();
    items = items.filter(function (it) { return it.el.isConnected; });
    items.forEach(function (it) { it.tick(n); });
    if (!items.length) stop();
  }
  function start() { if (timer || !items.length || document.hidden) return; tickAll(); timer = setInterval(tickAll, 30000); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  function init(root) {
    var found = (root.matches && root.matches('.dispatch-cd[data-dispatch-cutoff]')) ? [root] : [];
    if (root.querySelectorAll) found = found.concat([].slice.call(root.querySelectorAll('.dispatch-cd[data-dispatch-cutoff]')));
    found.forEach(function (el) {
      if (el.dataset.cdInit) return;
      el.dataset.cdInit = '1';
      var it = make(el); it.tick(madridNow()); items.push(it);
    });
    start();
  }

  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  // El carrito y el cajón reescriben su HTML por AJAX: se recogen las instancias nuevas.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) init(added[j]);
    }
  }).observe(document.body, { childList: true, subtree: true });

  window.gfDispatch = { init: init };
  init(document);
})();
